import { serializeParams } from "@/utils/apiUtils";
import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { EntityObject, TwoLevelEntityIdObject, TwoLevelEntityObject } from "../../../common/types";
import { AGENT_FILTER_INCLUSION_DEFAULTS, COMMON_AGENT_FILTER_QUERY_PARAMS } from "../../agent/api";
import { SpecialCommissionsReportScope } from "./enums";
import {
  CreateUpdateSpecialCommissionsSettingsRule,
  SpecialCommissionsReportFilterExportRequest,
  SpecialCommissionsReportFilterPageRequest,
  SpecialCommissionsReportFilterPageResult,
  SpecialCommissionsSettingsRule,
} from "./types";

const CREATE_SPECIAL_COMMISSIONS_RULE = ApiRequestAdapter.create(
  "/agents/{0}/special-commissions-settings/rules",
  HttpMethod.POST,
);
const UPDATE_SPECIAL_COMMISSIONS_RULE = ApiRequestAdapter.create(
  "/agents/{0}/special-commissions-settings/rules/{1}",
  HttpMethod.PUT,
);
const DELETE_SPECIAL_COMMISSIONS_RULE = ApiRequestAdapter.create(
  "/agents/{0}/special-commissions-settings/rules/{1}",
  HttpMethod.DELETE,
);

const GET_SPECIAL_COMMISSIONS_REPORT = ApiRequestAdapter.create("/special-commissions-report", HttpMethod.GET);

const DOWNLOAD_SPECIAL_COMMISSIONS_EXPORT = ApiRequestAdapter.create(
  "/special-commissions-report/export",
  HttpMethod.GET,
);

export const specialCommissionsApi = {
  createSpecialCommissionsRule: (
    request: EntityObject<CreateUpdateSpecialCommissionsSettingsRule>,
  ): AxiosPromise<SpecialCommissionsSettingsRule> => {
    return apiService.post(CREATE_SPECIAL_COMMISSIONS_RULE.getParametrizedUrl(request.id), request.object);
  },
  updateSpecialCommissionsRule: (
    request: TwoLevelEntityObject<CreateUpdateSpecialCommissionsSettingsRule>,
  ): AxiosPromise<SpecialCommissionsSettingsRule> => {
    return apiService.put(UPDATE_SPECIAL_COMMISSIONS_RULE.getParametrizedUrl(request.id1, request.id2), request.object);
  },
  deleteSpecialCommissionsRule: (request: TwoLevelEntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_SPECIAL_COMMISSIONS_RULE.getParametrizedUrl(request.id1, request.id2));
  },
  getSpecialCommissionsReport: (
    request: SpecialCommissionsReportFilterPageRequest,
  ): AxiosPromise<SpecialCommissionsReportFilterPageResult> => {
    return apiService.get(GET_SPECIAL_COMMISSIONS_REPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
    });
  },
  downloadSpecialCommissionsExport: (request: SpecialCommissionsReportFilterExportRequest): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_SPECIAL_COMMISSIONS_EXPORT.url, {
      params: request,
      paramsSerializer: { serialize: serializeParams },
      responseType: "blob",
    });
  },
};

export const DEFAULT_SPECIAL_COMMISSIONS_REPORT_QUERY_PARAMS: Required<SpecialCommissionsReportFilterPageRequest> = {
  ...COMMON_AGENT_FILTER_QUERY_PARAMS,
  ...AGENT_FILTER_INCLUSION_DEFAULTS.NONE_INCLUDED,
  specialCommissionKeyword: "",
  periodStartDate: "",
  periodEndDate: "",
  scope: SpecialCommissionsReportScope.PAYER,
};
